<template>
  <v-snackbar
    v-model="alertaNuevaRI.estatus"
    right
    top
    vertical
    color="transparent"
    class="text-center mb-0 pt-2 navidad-snackbar"
    :timeout="20000"
    @input="handleSnackbarChange"
  >
    <div class="navidad-wrap" :key="entradaKey">
      <v-btn
        class="navidad-close"
        fab
        x-small
        depressed
        color="#0b2a5e"
        dark
        @click="alertaNuevaRI.estatus = false"
      >
        <v-icon small>mdi-close</v-icon>
      </v-btn>

      <v-card class="elevation-0 navidad-card textoPoppins">
        <div class="navidad-cielo" aria-hidden="true">
          <span
            v-for="estrella in estrellas"
            :key="'estrella-' + estrella.id"
            class="estrella"
            :style="estrella.style"
          ></span>
          <div class="navidad-luna"></div>
        </div>

        <svg class="navidad-paisaje" viewBox="0 0 500 90" preserveAspectRatio="xMidYMax slice" aria-hidden="true">
          <path class="paisaje-montanas" d="M0,90 L0,55 L40,38 L80,50 L130,22 L175,45 L220,30 L270,48 L320,18 L370,44 L420,32 L470,50 L500,40 L500,90 Z" />
          <path class="paisaje-cimas" d="M130,22 L115.7,30 L122,28 L128,32 L135,28 L145.7,30 Z M320,18 L305,27 L312,25 L318,29 L326,25 L337.3,27 Z M220,30 L205,35 L211,34 L217,37 L224,34 L233.9,35 Z" />
          <path
            v-for="pino in pinos"
            :key="'pino-' + pino.id"
            :class="'paisaje-pino paisaje-pino--' + pino.fila"
            :d="pino.d"
          />
        </svg>

        <div class="navidad-luces" aria-hidden="true">
          <svg viewBox="0 0 500 44" preserveAspectRatio="none" class="luces-cable">
            <path :d="cablePath" />
          </svg>
          <span
            v-for="foco in focos"
            :key="'foco-' + foco.id"
            class="foco"
            :style="foco.style"
          >
            <span class="foco__luz"></span>
          </span>
        </div>

        <div class="navidad-scene" aria-hidden="true">
          <span
            v-for="copo in copos"
            :key="'copo-' + copo.id"
            class="copo"
            :style="copo.style"
          ></span>
          <span
            v-for="copo in coposRafaga"
            :key="'rafaga-copo-' + copo.id"
            class="copo-rafaga"
            :style="copo.style"
          ></span>
          <span
            v-for="n in 4"
            :key="'rafaga-' + n"
            class="rafaga"
            :class="'rafaga--' + n"
          ></span>
        </div>

        <v-card-title primary-title class="justify-center">
          <div class="navidad-personaje">
            <img :src="selectedImage" width="200" height="200" alt="" class="navidad-img" />
          </div>
        </v-card-title>

        <v-card-text class="navidad-text text-center textoPoppins">
          <div
            v-if="alertaNuevaRI.mensaje"
            style="white-space: pre-line"
            class="textoPoppins"
          >
            {{ alertaNuevaRI.mensaje.mensaje }}
          </div>
        </v-card-text>

        <svg class="navidad-nieve-base" viewBox="0 0 340 26" preserveAspectRatio="none" aria-hidden="true">
          <path d="M0,14 C30,4 55,18 90,10 C125,2 150,16 185,9 C220,2 250,17 285,8 C305,3 325,8 340,6 L340,26 L0,26 Z" />
        </svg>
      </v-card>
    </div>
  </v-snackbar>
</template>
<script>
import axios from 'axios';

  // Componentes
  import Alerta                from '@/components/alertas/Alerta.vue'
  import carga                 from '@/components/alertas/carga.vue';

  import validarErrores        from '@/mixins/validarErrores'
  import { mapGetters, mapActions }  from 'vuex';
  import funcionesExcel        from '@/mixins/funcionesExcel'

  const SWAGS   = 6;
  const ANCHO   = 500;
  const Y_BASE  = 4;
  const CAIDA   = 60;
  const COLORES = ['#ff5252', '#ffd740', '#69f0ae', '#40c4ff', '#ff80ab'];


  export default {

    components:{
      Alerta,
      carga,
    },


    mixins: [ validarErrores, funcionesExcel ],

    props:[
      'alertaNuevaRI',
    ],

    computed: {
      ...mapGetters('login', ['getdatosUsuarioERPERP', 'getLogeado', 'getEscuela','drawer2','getEstatusLlamada','getNuevosProspectos']),

      cablePath() {
        const tramo = ANCHO / SWAGS;
        let d = `M0,${Y_BASE}`;
        for (let i = 0; i < SWAGS; i++) {
          d += ` Q${tramo * i + tramo / 2},${Y_BASE + CAIDA / 2} ${tramo * (i + 1)},${Y_BASE}`;
        }
        return d;
      },

      focos() {
        const tramo = ANCHO / SWAGS;
        const posiciones = [0.2, 0.5, 0.8];
        const lista = [];
        for (let s = 0; s < SWAGS; s++) {
          posiciones.forEach((t) => {
            const i = lista.length;
            const x = tramo * s + tramo * t;
            const y = Y_BASE + CAIDA * t * (1 - t);
            const angulo = Math.atan((CAIDA * (1 - 2 * t)) / tramo) * 180 / Math.PI;
            lista.push({
              id: i,
              style: {
                left: `${(x / ANCHO) * 100}%`,
                top: `${y}px`,
                transform: `translateX(-50%) rotate(${angulo.toFixed(1)}deg)`,
                '--c': COLORES[i % COLORES.length],
                '--delay': `${(i % 3) * 0.45}s`,
                '--dur': `${1.3 + (i % 4) * 0.25}s`,
              }
            });
          });
        }
        return lista;
      },

      pinos() {
        const BASE = 88;
        const arbol = (x, h) => {
          const top = BASE - h;
          const w = h * 0.62;
          const nivel = (dy, alto, ancho) =>
            `M${x},${(top + h * dy).toFixed(1)} L${(x - ancho / 2).toFixed(1)},${(top + h * (dy + alto)).toFixed(1)} L${(x + ancho / 2).toFixed(1)},${(top + h * (dy + alto)).toFixed(1)} Z`;
          return nivel(0, 0.4, w * 0.55) + ' ' + nivel(0.22, 0.42, w * 0.78) + ' ' + nivel(0.48, 0.52, w);
        };

        const lista = [];
        for (let i = 0; i < 14; i++) {
          lista.push({ id: lista.length, fila: 'atras', d: arbol(18 + i * 36 + (i % 2) * 6, 26 + ((i * 7) % 5) * 3) });
        }

        const frente = [
          [10, 52], [42, 44], [78, 58], [112, 40], [160, 30], [205, 26],
          [300, 28], [345, 32], [392, 42], [428, 56], [462, 46], [494, 54],
        ];
        frente.forEach(([x, h]) => {
          lista.push({ id: lista.length, fila: 'frente', d: arbol(x, h) });
        });

        return lista;
      },
    },

    data: () => ({
      // Alertas
      parametros:{
        dialogError: false,
        mensaje: '',
        color: ''
      },

      respuestaAlerta:false,
      loader: true,
      cargar: false,

      motivo: '',
      sonido: null,
      volumen: 0.1,

      entradaKey: 0,
      copos: [],
      coposRafaga: [],
      estrellas: [],

      images: [
        require("@/assets/images/navidad/santa.png"),
        require("@/assets/images/navidad/galleta.png"),
        require("@/assets/images/navidad/muneco.png"),
        require("@/assets/images/navidad/arbol.png"),
        require("@/assets/images/navidad/reno.png"),
        require("@/assets/images/navidad/duende.png"),
      ],

      selectedImage: null
    }),

    watch: {
      'alertaNuevaRI.estatus': {
        immediate: true,
        handler(newVal) {
          if (newVal) {
            this.entradaKey++;
            this.pickRandomImage();
            this.generarEscena();
            this.reproducirSonido();
          }
        }
      }
    },

    created() {
      this.sonido = document.createElement("audio");
      this.sonido.src = "/navidad.mp3";
      this.sonido.setAttribute("preload", "auto");
      this.sonido.setAttribute("controls", "none");
      this.sonido.style.display = "none";
      this.sonido.volume = this.volumen;
      document.body.appendChild(this.sonido);

      this.images.forEach((src) => {
        const img = new Image();
        img.src = src;
      });
    },

    beforeDestroy() {
      // Limpieza del elemento de audio cuando el componente se destruye
      if (this.sonido) {
        document.body.removeChild(this.sonido);
        this.sonido = null;
      }
    },

    methods:{

      handleSnackbarChange(value) {
        if (value) {
          this.reproducirSonido();
        }
      },

      reproducirSonido() {
        if (this.sonido) {
          this.sonido.volume = this.volumen;
          this.sonido.play().then(() => {
          }).catch((error) => {
            console.error("Error al reproducir el audio:", error);
          });
        }
      },

      cerrar() {
        if (this.sonido) {
          this.sonido.pause();
          this.sonido.currentTime = 0;
        }
        this.alertaNuevaRI.estatus = false;
      },

      generarEscena() {
        this.copos = Array.from({ length: 42 }, (_, i) => {
          const size = 2 + Math.random() * 4;
          return {
            id: i,
            style: {
              left: `${Math.random() * 100}%`,
              width: `${size}px`,
              height: `${size}px`,
              opacity: (0.45 + Math.random() * 0.5).toFixed(2),
              filter: size < 3.5 ? 'blur(0.6px)' : 'none',
              animationDuration: `${6 + Math.random() * 6}s`,
              animationDelay: `-${(Math.random() * 10).toFixed(2)}s`,
              '--drift': `${(-60 + Math.random() * 50).toFixed(1)}px`,
              '--sway': `${(Math.random() * 30 - 15).toFixed(1)}px`,
            }
          };
        });

        this.coposRafaga = Array.from({ length: 20 }, (_, i) => {
          const size = 2 + Math.random() * 3;
          return {
            id: i,
            style: {
              top: `${10 + Math.random() * 75}%`,
              width: `${size}px`,
              height: `${size}px`,
              animationDelay: `${(Math.random() * 0.6).toFixed(2)}s`,
              animationDuration: `${(1.1 + Math.random() * 0.8).toFixed(2)}s`,
              '--dy': `${(Math.random() * 60 - 10).toFixed(1)}px`,
            }
          };
        });

        this.estrellas = Array.from({ length: 18 }, (_, i) => {
          const size = 1.5 + Math.random() * 1.5;
          return {
            id: i,
            style: {
              top: `${4 + Math.random() * 50}%`,
              left: `${Math.random() * 100}%`,
              width: `${size}px`,
              height: `${size}px`,
              animationDelay: `${(Math.random() * 3).toFixed(2)}s`,
              animationDuration: `${(2 + Math.random() * 2).toFixed(2)}s`,
            }
          };
        });
      },

      pickRandomImage() {
        const index = Math.floor(Math.random() * this.images.length);
        this.selectedImage = this.images[index];
      },

    }
  }
</script>

<style scoped>
  .textoPoppins {
    font-family: 'Poppins', sans-serif !important;
  }

  .navidad-snackbar ::v-deep .v-snack__wrapper {
    background: transparent !important;
    box-shadow: none !important;
    max-width: 500px !important;
    min-width: 250px !important;
    width: 500px !important;
  }

  .navidad-snackbar ::v-deep .v-snack__content {
    align-self: stretch !important;
    width: 100% !important;
    padding: 12px 10px !important;
    margin-right: 0 !important;
    overflow: visible !important;
  }

  /* Entrada: la tarjeta llega empujada por el viento y se mece como un letrero colgado */
  .navidad-wrap {
    position: relative;
    width: 100%;
    transform-origin: 50% 0;
    animation: viento-entrada 1.15s cubic-bezier(0.2, 0.8, 0.2, 1) both;
  }

  @keyframes viento-entrada {
    0%   { opacity: 0; transform: translateX(110%) rotate(6deg) skewX(-12deg); }
    45%  { opacity: 1; transform: translateX(-5%) rotate(-2.5deg) skewX(5deg); }
    65%  { transform: translateX(2.5%) rotate(1.2deg) skewX(-2deg); }
    82%  { transform: translateX(-1%) rotate(-0.5deg) skewX(0.8deg); }
    100% { transform: none; }
  }

  .navidad-close {
    position: absolute !important;
    top: -10px;
    right: -10px;
    z-index: 10;
    border: 2px solid #b3e5fc !important;
    box-shadow: 0 0 10px rgba(64, 196, 255, 0.55) !important;
  }

  .navidad-card {
    position: relative;
    width: 100%;
    background:
      linear-gradient(180deg, #0a1f44 0%, #12408a 50%, #2b78d0 100%) !important;
    border: 1px solid rgba(179, 229, 252, 0.65) !important;
    border-radius: 14px !important;
    box-shadow:
      0 0 0 1px rgba(13, 71, 161, 0.25),
      0 0 22px rgba(64, 196, 255, 0.35),
      0 12px 30px rgba(5, 20, 50, 0.45) !important;
    overflow: hidden;
  }

  .navidad-card ::v-deep .v-card__title {
    position: relative;
    z-index: 2;
    padding: 34px 10px 0 !important;
    margin-bottom: -12px !important;
  }

  .navidad-card ::v-deep .v-card__text {
    position: relative;
    z-index: 6;
    padding: 0 16px 22px !important;
    margin-top: 0 !important;
  }

  .navidad-text {
    color: #ffffff !important;
    font-size: 13px !important;
    font-weight: 500;
    line-height: 1.6;
    text-shadow: 0 0 8px rgba(144, 202, 249, 0.8), 0 1px 2px rgba(0, 0, 0, 0.4);
    animation: texto-aparecer 0.6s 0.75s ease-out both;
  }

  @keyframes texto-aparecer {
    from { opacity: 0; transform: translateY(8px); }
    to   { opacity: 1; transform: none; }
  }

  /* Cielo nocturno */
  .navidad-cielo {
    position: absolute;
    inset: 0;
    z-index: 0;
    pointer-events: none;
  }

  .navidad-luna {
    position: absolute;
    left: 50%;
    top: 42%;
    width: 300px;
    height: 300px;
    transform: translate(-50%, -50%);
    border-radius: 50%;
    background: radial-gradient(circle, rgba(187, 222, 251, 0.55) 0%, rgba(144, 202, 249, 0.18) 45%, transparent 70%);
  }

  .estrella {
    position: absolute;
    border-radius: 50%;
    background: #ffffff;
    box-shadow: 0 0 4px 1px rgba(255, 255, 255, 0.8);
    animation-name: estrella-titilar;
    animation-iteration-count: infinite;
    animation-timing-function: ease-in-out;
  }

  @keyframes estrella-titilar {
    0%, 100% { opacity: 0.25; transform: scale(0.8); }
    50%      { opacity: 1;    transform: scale(1.2); }
  }

  /* Serie navideña */
  .navidad-luces {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 44px;
    z-index: 7;
    pointer-events: none;
  }

  .luces-cable {
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
    overflow: visible;
  }

  .luces-cable path {
    fill: none;
    stroke: #4caf7d;
    stroke-width: 2.2;
    stroke-linecap: round;
    filter: drop-shadow(0 0 2px rgba(200, 255, 220, 0.55));
  }

  .foco {
    position: absolute;
    width: 9px;
    height: 16px;
    transform-origin: 50% 0;
  }

  .foco::before {
    content: '';
    position: absolute;
    top: 0;
    left: 1.5px;
    width: 6px;
    height: 5px;
    border-radius: 1px;
    background: #2e6b4a;
  }

  .foco__luz {
    position: absolute;
    top: 4px;
    left: 0;
    width: 9px;
    height: 12px;
    border-radius: 50% 50% 50% 50% / 40% 40% 60% 60%;
    background: radial-gradient(circle at 35% 30%, #ffffff 0 12%, var(--c) 48%);
    box-shadow: 0 0 6px 2px var(--c), 0 0 16px 4px var(--c);
    animation: foco-parpadeo var(--dur, 1.5s) var(--delay, 0s) ease-in-out infinite;
  }

  @keyframes foco-parpadeo {
    0%, 100% { opacity: 1;    box-shadow: 0 0 6px 2px var(--c), 0 0 16px 4px var(--c); }
    50%      { opacity: 0.35; box-shadow: 0 0 2px 0 var(--c); }
  }

  /* Nieve y viento */
  .navidad-scene {
    position: absolute;
    inset: 0;
    overflow: hidden;
    z-index: 4;
    pointer-events: none;
  }

  .copo {
    position: absolute;
    top: -10px;
    border-radius: 50%;
    background: #ffffff;
    animation-name: copo-caer;
    animation-timing-function: linear;
    animation-iteration-count: infinite;
  }

  @keyframes copo-caer {
    0%   { transform: translate3d(0, -10px, 0); }
    50%  { transform: translate3d(calc(var(--drift, -20px) * 0.4 + var(--sway, 0px)), 240px, 0); }
    100% { transform: translate3d(var(--drift, -20px), 500px, 0); }
  }

  .copo-rafaga {
    position: absolute;
    left: 100%;
    border-radius: 50%;
    background: #ffffff;
    opacity: 0;
    filter: blur(0.4px);
    animation-name: copo-volar;
    animation-timing-function: cubic-bezier(0.25, 0.6, 0.3, 1);
    animation-fill-mode: forwards;
  }

  @keyframes copo-volar {
    0%   { opacity: 0;   transform: translate3d(0, 0, 0); }
    15%  { opacity: 0.95; }
    100% { opacity: 0;   transform: translate3d(-640px, var(--dy, 20px), 0); }
  }

  .rafaga {
    position: absolute;
    right: -160px;
    width: 150px;
    height: 18px;
    border-top: 2px solid rgba(255, 255, 255, 0.75);
    border-radius: 50%;
    opacity: 0;
    animation: rafaga-pasar 1.3s ease-out forwards;
  }

  .rafaga--1 { top: 22%; animation-delay: 0.05s; }
  .rafaga--2 { top: 40%; animation-delay: 0.2s; width: 120px; }
  .rafaga--3 { top: 58%; animation-delay: 0.35s; }
  .rafaga--4 { top: 76%; animation-delay: 0.5s; width: 100px; }

  @keyframes rafaga-pasar {
    0%   { opacity: 0;   transform: translateX(0) scaleX(0.6); }
    15%  { opacity: 0.9; }
    100% { opacity: 0;   transform: translateX(-800px) scaleX(1.2); }
  }

  /* Personaje */
  .navidad-personaje {
    display: flex;
    justify-content: center;
    width: 100%;
    animation:
      personaje-aparecer 0.8s 0.45s cubic-bezier(0.3, 1.4, 0.5, 1) both,
      personaje-flotar 4s 1.3s ease-in-out infinite;
  }

  @keyframes personaje-aparecer {
    0%   { opacity: 0; transform: scale(0.6) rotate(-8deg); }
    100% { opacity: 1; transform: scale(1) rotate(0deg); }
  }

  @keyframes personaje-flotar {
    0%, 100% { transform: translateY(0) rotate(0deg); }
    25%      { transform: translateY(-4px) rotate(1.5deg); }
    75%      { transform: translateY(-2px) rotate(-1.5deg); }
  }

  .navidad-img {
    display: block;
    width: 200px;
    height: 200px;
    object-fit: contain;
    filter: drop-shadow(0 8px 16px rgba(3, 20, 60, 0.55));
  }

  .navidad-nieve-base {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    width: 100%;
    height: 24px;
    z-index: 5;
    pointer-events: none;
    filter: drop-shadow(0 -2px 4px rgba(255, 255, 255, 0.35));
  }

  .navidad-nieve-base path {
    fill: #f3f9ff;
  }

  /* Paisaje nevado */
  .navidad-paisaje {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    width: 100%;
    height: 90px;
    z-index: 1;
    pointer-events: none;
  }

  .paisaje-montanas {
    fill: rgba(144, 202, 249, 0.22);
  }

  .paisaje-cimas {
    fill: rgba(255, 255, 255, 0.4);
  }

  .paisaje-pino--atras {
    fill: #1a4f96;
    opacity: 0.75;
  }

  .paisaje-pino--frente {
    fill: #0b2552;
  }

  @media (prefers-reduced-motion: reduce) {
    .navidad-wrap,
    .navidad-personaje,
    .navidad-text,
    .foco__luz,
    .estrella,
    .copo {
      animation: none !important;
    }

    .copo-rafaga,
    .rafaga {
      display: none;
    }
  }
</style>
